import { api_DELETE, api_GET, api_POST, api_PUT } from './_api';

const programacaoColeta_api = {
    GetList: (data) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`/ProgramacaoColeta/GetList/${data}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;

    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`/ProgramacaoColeta/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetListGeradoresProgramacaoOrdem: (idOrdem, data, idRota, tipoColetaId) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`/ProgramacaoColeta/GetListGeradoresProgramacaoOrdem/${idOrdem}/${data}/${idRota}/${tipoColetaId}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;

    },
    GetListAllGeradoresProgramacaoOrdem: (tipoColetaId) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`/ProgramacaoColeta/GetListAllGeradoresProgramacaoOrdem/${tipoColetaId}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;

    },
    GetVeiculosDisponiveis: (id = 0) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ProgramacaoColeta/GetVeiculosDisponiveis/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }, GetMotoristasDisponiveis: (id = 0) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ProgramacaoColeta/GetMotoristasDisponiveis/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`/ProgramacaoColeta`, model)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    Put: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`/ProgramacaoColeta`, model)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    Delete: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`/ProgramacaoColeta/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    GetDestinosDisponiveisPorVeiculoEOrdem: (id, ordemId) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ProgramacaoColeta/GetDestinosPorVeiculoEOrdem/${id}/${ordemId}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default programacaoColeta_api;